// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__CIHcj","checkboxCol":"Table_checkboxCol__1c0jA","emailCol":"Table_emailCol__GS5KE","actionCol":"Table_actionCol__3uYVT"};